import type { UndefinedOnPartialDeep } from 'type-fest';

import { translate } from '@repo/phrase';
import type { Service } from '@repo/types/service';
import { Paragraph } from '@repo/ui/typography';

import { formatServiceTimeWindow } from '@/utils/services.utils';

interface Props {
    service: UndefinedOnPartialDeep<Service>;
    isOrder: boolean;
}

export const ServiceTimeWindow = ({ service, isOrder }: Props) => {
    // Show as reference booking for quotations & drafts since only the article price is promised, not delivery dates/timeslots.
    if (!isOrder) {
        return <div data-testid="service-table-reference-booking">{translate('services_table_reference_booking')}</div>;
    }

    if (!service.timeWindow) {
        return null;
    }

    return (
        <div>
            {service.subDeliveries?.map((subDelivery) => (
                <Paragraph key={subDelivery.id}>
                    {formatServiceTimeWindow(service.isDelivery, subDelivery.timeWindow)}
                </Paragraph>
            ))}

            <Paragraph>{formatServiceTimeWindow(service.isDelivery, service.timeWindow)}</Paragraph>
        </div>
    );
};
